import React from 'react';
import { cn } from '@/lib/utils'; // Assuming you have this utility

interface BackgroundProps extends React.HTMLAttributes<HTMLDivElement> {
	children: React.ReactNode;
	className?: string;
}

const Background: React.FC<BackgroundProps> = ({
	children,
	className,
	...props
}) => {
	return (
		<div
			className={cn("min-h-screen bg-background-default",
				className
			)}
			{...props}
		>
			{children}
		</div>
	);
};

export default Background;